import React from 'react'
import './ManualPage.scss'
import attachment91916714 from '../../assets/manual/attachments/91916714.png'
import attachment181010584 from '../../assets/manual/attachments/181010584.png'
import attachment91917193 from '../../assets/manual/attachments/91917193.png'
import attachment180846730 from '../../assets/manual/attachments/180846730.png'
import attachment179994683 from '../../assets/manual/attachments/179994683.png'
import attachment180027499 from '../../assets/manual/attachments/180027499.png'
import attachment180945092 from '../../assets/manual/attachments/180945092.png'
import attachment180945109 from '../../assets/manual/attachments/180945109.png'
import attachment284229636 from '../../assets/manual/attachments/284229636.png'
import attachment284098579 from '../../assets/manual/attachments/284098579.png'
import attachment91916784 from '../../assets/manual/attachments/91916784.png'
import attachment91916858 from '../../assets/manual/attachments/91916858.png'
import attachment180977801 from '../../assets/manual/attachments/180977801.png'
import attachment284229656 from '../../assets/manual/attachments/284229656.png'
import attachment92969196 from '../../assets/manual/attachments/92969196.png'
import attachment111935502 from '../../assets/manual/attachments/111935502.png'
import attachment92970935 from '../../assets/manual/attachments/92970935.png'
import attachment92998910 from '../../assets/manual/attachments/92998910.png'
import attachment91916770 from '../../assets/manual/attachments/91916770.png'

export const ManualPage: React.FunctionComponent<{}> = () => {
  return (
    <>
      <div data-component="manualpage-component">
        <div className="panel reference-box">
          <div className="panel-heading">
            Item Tracing: Manual
            <span className="page-metadata">Last updated on Oct 15, 2018</span>
          </div>
          <div className="panel-body">
            <div id="main-content" className="wiki-content group">
              <h1 id="Manual-Prerequisites">Prerequisites</h1>
              <p>
                The Item Tracing system has been tested and verified with
                <em>Google Chrome, Mozilla Firefox </em>and
                <em> Microsoft Edge</em> web browsers. Other browsers such as Safari is known to have limitations and
                will not provide a correct user experience. Please avoid older browsers especially
                <em>Internet Explorer</em> as this will
                <strong>not work</strong> with Item Tracing System.
              </p>
              <p>
                Also please ensure that you system time is synced with time servers of your location and not changed in
                any way.
              </p>
              <h1 id="Manual-Loggingin">Logging in</h1>
              <p>
                When the user has successfully verified the email and the admins have confirmed the account, the user
                can log on to the following URL:
                <br />
                <a href="https://itemtracing.danielwellington.com" className="external-link" rel="nofollow">
                  https://itemtracing.danielwellington.com
                </a>
              </p>
              <p>Where the following screen will appear:</p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment91916714}
                    data-image-src={attachment91916714}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="91916714"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="Screen Shot 2017-02-20 at 14.28.03.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="33f5e3a8-e84e-4436-bf76-a7e9a4b8f1fa"
                    data-media-type="file"
                    alt="Log in form with username and password fields"
                  />
                </span>
                 
              </p>
              <p>
                <br />
              </p>
              <p>
                The user can now fill in the Email and the password they registered with and then click on
                <em>Log In</em>.
              </p>
              <h1 id="Manual-UserRoles">User Roles</h1>
              <p>
                ITS has four different roles which gives users permissions to perform different actions. When a user
                signs up the admins will confirm the user and assign the user one or multiple roles.
              </p>
              <p>The roles that exist in ITS are:</p>
              <ul>
                <li>A - Can perform scanning</li>
                <li>A1 - Can perform scanning with additional store info</li>
                <li>B - Can search for serial numbers and order numbers</li>
                <li>B1 - Can search for serial numbers and order number and export to Excel</li>
                <li>C - Can search for batch numbers</li>
                <li>D - Can perform authentic check</li>
                <li>D1 - Can perform authentic check with additional search results and reason</li>
              </ul>
              <h1 id="Manual-Scanning">Scanning</h1>
              <h2 id="Manual-Prerequisites.1">Prerequisites</h2>
              <p>
                In order to perform a scan with the
                <em> Item Tracing System</em>, the user needs to have a barcode scanner that can read EAN codes and QR
                codes. The system has been tested to work properly with – but not limited to – the CipherLab 1564A hand
                scanner. Other CipherLab scanners in the series are also known to work with the system. Also please
                ensure that you have
                <strong>english keyboard</strong> installed and selected in your system.
              </p>
              <h2 id="Manual-Overview">Overview</h2>
              <p>When logged in, the user will see the following screen:</p>
              <h1 id="Manual-">
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment181010584}
                    data-image-src={attachment181010584}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="181010584"
                    data-linked-resource-version="2"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="scanning-overview.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="be70129d-8083-40b1-85bb-38400070d278"
                    data-media-type="file"
                    alt="Scan page view"
                  />
                </span>
              </h1>
              <p>
                <br />
              </p>
              <h2 id="Manual-Scanningprocess">Scanning process</h2>
              <p>
                The Scan process consists of three stages shown below. When the scan has been finished, the process can
                be repeated with the Header already filled for faster handling.
              </p>
              <p>
                <strong>
                  <em>Important: </em>
                </strong>
                <em>Each send may refer to only one article number and one order number but many serial numbers. </em>
                When a send has been done, the order number and article number will remain filled in the fields to be
                used again in next scan. The serial numbers work as the keys when rows are stored in the system.
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper">
                  <img
                    className="confluence-embedded-image"
                    src={attachment91917193}
                    data-image-src={attachment91917193}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="91917193"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="Screen Shot 2017-02-24 at 10.03.04.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="443b9638-911e-4f5e-9dde-463a3832b097"
                    data-media-type="file"
                    alt="Step by step guide with following steps: fill out header, perform scan, adjust & send"
                  />
                </span>
              </p>
              <h2 id="Manual-Header">Header</h2>
              <p>
                Before the user begins to scan, it is recommended that the user fills out the header information
                consisting of the following fields:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment180846730}
                    data-image-src={attachment180846730}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="180846730"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="scanning-header.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="e45bc903-3272-4e8c-ba9b-7eb6766377a6"
                    data-media-type="file"
                    alt="Scan page form"
                  />
                </span>
              </p>
              <ul>
                <li>
                  <em>Order No:</em> The Order No the user is working on
                </li>
                <li>
                  <em>Article No:</em>
                  <ul>
                    <li>
                      Can be entered manually (for example DW00100002, old article numbers such as 0101DW can not be
                      used) or
                    </li>
                    <li>
                      By scanning EAN code after
                      <em>blurs</em>
                      <span style={{ color: 'rgb(51,51,51)', textDecoration: 'none' }}>
                        {' '}
                        (leaves, inactivates) all fields and EAN
                      </span>{' '}
                      will be checked against a list of valid article numbers table and changed to article number (for
                      example DW00100002)
                    </li>
                  </ul>
                </li>
                <li>
                  <em>Trace Type:</em>
                  <ul>
                    <li>
                      <em>Inbound: </em>to be used when a purchase or transfer order is received at the warehouse
                    </li>
                    <li>
                      <em>Outbound: </em>to be used when a sales or transfer order is sent from the warehouse
                    </li>
                    <li>
                      <em>Discarded: </em>to be used when the serial number is no longer for sale, for example due to
                      quality issues
                    </li>
                    <li>
                      <em>Stolen:</em> to be used when serial numbers are identified as stolen
                    </li>
                    <li>
                      <em>Returned:</em> to be used for all return orders from customers
                    </li>
                  </ul>
                </li>
                <li>
                  <em>Trace Date: </em>The date of the event, usually the same day (pre-filled)
                </li>
                <li>
                  <em>Location:</em> Select your location in the list of locations available to the user
                </li>
              </ul>
              <p>
                <strong>
                  <em>Important: </em>
                </strong>
                <em>
                  Each scan should have
                  <strong>only one</strong> product ID/article number.
                </em>
              </p>
              <p>If a user has the role A1, the user will be able to add a Ship To field to the header.</p>
              <h3 id="Manual-Ordernumberfetching">Order number fetching</h3>
              <p>
                When an order number is entered, the serial numbers belonging to that order number is fetched and
                grouped by the article number/product id. An order number can also be scanned, the page will
                automatically be able to distinguish it from article or serial numbers. The application then first looks
                up the order number in NAV to ensure what that order should contain and then also looks up the same for
                previously scanned serials in ITS.
              </p>
              <p>
                <br />
              </p>
              <p>
                When the user enters an order number and then
                <em>blurs</em> (leaves, inactivates) the field, i.e to fill out the next field OR scans an order number,
                the search begins automatically.
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="150"
                    src={attachment179994683}
                    data-image-src={attachment179994683}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="179994683"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="ordersearch01.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="485ce6ef-4314-4a8c-9a98-53b2a98e65cf"
                    data-media-type="file"
                    alt="Search for the orderNo loading"
                  />
                </span>
              </p>
              <p>
                If results are found they will be presented as shown below grouped by article number and
                <em>amount scanned/amount in order</em>:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment180027499}
                    data-image-src={attachment180027499}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="180027499"
                    data-linked-resource-version="2"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="ordersearchresults.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="6d90e0e3-263e-4bf9-82f4-7981e24d706f"
                    data-media-type="file"
                    alt="OrderNo table"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>
                Each subsequent completed scan on the same order number will be added to the
                <em>amount</em> in the list shown above.
              </p>
              <p>
                <strong>Important</strong>: When doing a scan, users should be aware of the delay of up to 10 minutes in
                the data entereing the database making it available for search in the
                <strong>serial/order search</strong>. This is due to queing in the back end.
              </p>
              <p>
                <br />
              </p>
              <h2 id="Manual-Scanningserialnumbers">Scanning serial numbers</h2>
              <p>
                The scanning is done with the use of a scanning device that is able to read EAN and QR-codes. The
                application has been tested to work with the CipherLab 1564A hand held scanner, but will work with many
                other scanners too.
              </p>
              <p>
                <strong>Important:</strong>
                <em>
                  The computer/device connected to the scanner must be set to use
                  <strong>English keyboard</strong> in order for the scanning to work.
                </em>
              </p>
              <h3 id="Manual-Scanningmultipleserials/boxes">Scanning multiple serials/boxes</h3>
              <p>
                When the header has been filled, make sure no field is active on the form and perform a scan. The
                application will now recognize the pattern of the serials stored in the QR label and read them
                accordingly as shown in the following screen:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment180945092}
                    data-image-src={attachment180945092}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="180945092"
                    data-linked-resource-version="2"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="scanning-correct.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="5f9e0270-955c-476f-9b31-85dbfae904bd"
                    data-media-type="file"
                    alt="Box with enabling delete mode button, multiple serials and clear all button"
                  />
                </span>
              </p>
              <p>
                Each scan creates a<em>serial group</em> containing the number of serial numbers in that scan.
              </p>
              <p>
                A user can do as many scans as they wish on the same order. Each scan will create a new
                <em>serial group</em>. 
              </p>
              <p>
                The application has a built-in duplicate check , that ensures that each serial only can be scanned once
                for each
                <em>sending</em>. More info on
                <em>sending</em> further on in this document.
              </p>
              <p>
                <strong>
                  <em>Important: </em>
                </strong>
                <em>The max amount to scan is 4000, if  the limit is reached please send then scan again.</em>
              </p>
              <h3 id="Manual-Manuallyinsertingserials">Manually inserting serials</h3>
              <p>
                In case the user needs to enter serial numbers manually, this can be done by first clicking the
                &quot;Manual Input&quot; button and then typing them into the field that appears (shown below) and
                clicking on the “+” sign.
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="150"
                    src={attachment180945109}
                    data-image-src={attachment180945109}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="180945109"
                    data-linked-resource-version="2"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="manual-serial.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="ecbb3bc9-fde8-45f3-985d-901ded49880f"
                    data-media-type="file"
                    alt="Box with activated delete mode"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <h3 id="Manual-Deletingserialnumbers">Deleting serial numbers</h3>
              <p>
                Each serial number can be deleted by clicking on the red cross beside that number and each group can be
                deleted all together by clicking the large red cross to the left of each group.
                <strong>
                  <em>Note: The red crosses only appears when the user hovers over the groups with the mouse.</em>
                </strong>
              </p>
              <p>The user can also delete all scanned items by clicking the “Clear all” button.</p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment284229636}
                    data-image-src={attachment284229636}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="284229636"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="delete-scan.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="3fd8dce9-ffc6-4005-aaa8-f3510d0e14e9"
                    data-media-type="file"
                    alt="Clear all button functionality"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>
                There is also the possibility to delete separate
                <em>scan groups</em> through the scanner by activating the
                <em>delete mode</em>. To activate the
                <em>delete mode</em> the user must click the “Activate Delete Mode” button. When this button is clicked
                and
                <em>delete mode</em> is active, the button will become black, like shown in the screen below:
              </p>
              <p>
                <br />
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment284098579}
                    data-image-src={attachment284098579}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="284098579"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="delete-mode-scan.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="d0eb4353-4da2-485f-bcf9-9e1d9dce1636"
                    data-media-type="file"
                    alt="Form with input and plus button"
                  />
                </span>
              </p>
              <p>
                The user can now scan the previously scanned groups and they will be removed from the serials on the
                screen. To deactivate the
                <em>delete mode</em> the user can click anywhere on the screen in the application.
              </p>
              <h3 id="Manual-Sending">Sending</h3>
              <p>
                When the
                <em>header </em>and the
                <em>scanning</em> has been completed the user is ready to send the data. This is done by clicking the
                “Send” button.
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment91916784}
                    data-image-src={attachment91916784}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="91916784"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="Screen Shot 2017-02-20 at 15.07.16.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="287cc82f-777b-4c4b-bb3f-0063f7725fbf"
                    data-media-type="file"
                    alt="Send button"
                  />
                </span>
              </p>
              <p>
                This will send the data to the Item Tracing system and display the sent amount of serials as shown
                below:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="400"
                    src={attachment91916858}
                    data-image-src={attachment91916858}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="91916858"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="Screen Shot 2017-02-20 at 15.28.31.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="81872d40-9486-40cf-9413-4f0f88a6c41c"
                    data-media-type="file"
                    alt="Successfully sent serials, box shows text with amount of serials sent"
                  />
                </span>
              </p>
              <p>
                <strong>
                  <em>Important: </em>
                </strong>
                <em>
                  Each sending may contain only one article number and one order number. The scans are stored in rows
                  where the serial numbers work as keys.
                </em>
              </p>
              <p>
                <em>
                  <br />
                </em>
              </p>
              <h1 id="Manual-Serial/Ordersearch">Serial/Order search</h1>
              <p>
                Searching is only available to users with the user roles B or B1. The user can search for either a order
                number or a single serial number by clicking “Serial/Order Search” in the main navigation menu on the
                top of the application.
              </p>
              <p>
                Then the user can type the order number or serial number into the search field and click “Search”. When
                searching for a order number you will see the items of that order as in the following screen:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    width="400"
                    src={attachment180977801}
                    data-image-src={attachment180977801}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="180977801"
                    data-linked-resource-version="2"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="serialorder-search.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="d2b875cf-f20e-440e-8b38-e90508c20aab"
                    data-media-type="file"
                    alt="Order number table with ability to export"
                  />
                </span>
              </p>
              <p>Here the user can see all the information about the order number such as:</p>
              <ul>
                <li>
                  <em>Article Number:</em> The article ids belonging to the order number
                </li>
                <li>
                  <em>Count: </em>The serial number counts belonging to the articles
                </li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                To copy all the serial numbers of a order number click the
                <em>Export-&gt;</em>
                <em>Copy All</em> button on the right of the results heading.
              </p>
              <p>
                The user can click on a column header to sort the table according to that column i.e. clicking
                &quot;Trace Time&quot; will sort the table according to the time of the scan in descending or ascending
                order.
              </p>
              <p>
                The user can search individual serial numbers to see the information in descending order as shown below:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="400"
                    src={attachment284229656}
                    data-image-src={attachment284229656}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="284229656"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="serialsearchresults.PNG"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="d070cafb-5537-4c4a-b62a-4c0b29a2f4b0"
                    data-media-type="file"
                    alt="Serial number table"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>Here the user can see all the information about the serial number such as:</p>
              <ul>
                <li>
                  <em>Trace Time:</em> The time when the serial number was scanned
                </li>
                <li>
                  <em>Scanning Type: </em>The type of scanning performed
                </li>
                <li>
                  <em>Order Number:</em> The order number the serial number belongs to
                </li>
                <li>
                  <em>Article number: </em>The product identifier
                </li>
                <li>
                  <em>User Location: </em>Where the serial number was scanned
                </li>
                <li>
                  <em>Scanned By:</em> User name of the user scanning the row
                </li>
                <li>
                  <em>Received By</em>: Where the watch belonging to the serial number was sent
                </li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                The user can click the batch number in the header of the results to view the information about the batch
                number the serial number belongs to (if user has correct permissions)
              </p>
              <p>
                <br />
              </p>
              <h1 id="Manual-BatchNumbers">Batch Numbers</h1>
              <p>
                Searching for batch numbers is only available to users with the user role C. The user can search for
                batch number by clicking “Batch Search” in the main navigation menu on the top of the application.
              </p>
              <p>
                Then the user can type the batch number into the search field and click “Search”. The user will then see
                the amount of serial numbers, and the range of serial numbers with the starting and ending serial
                numbers of that batch number as in the following screen:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment92969196}
                    data-image-src={attachment92969196}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="92969196"
                    data-linked-resource-version="3"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="batch-numbers.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="636f49e0-b5a1-4b00-b631-44703064b8ce"
                    data-media-type="file"
                    alt="Batch number form with send button; Batch number table"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <h1 id="Manual-AuthenticCheck">Authentic Check</h1>
              <p>
                A user with permission D or D1 can perform a authentic check on a specific watch by filling in the form
                shown below. User with D permissions will get an answer on whether or not the watch is authentic while
                user with D1 permissions will get a more detailed answer on the reason and trace history (if available)
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment111935502}
                    data-image-src={attachment111935502}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="111935502"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="Screen Shot 2017-11-10 at 09.56.16.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="60d362e8-4b70-4109-a9c7-d24f27d77444"
                    data-media-type="file"
                    alt="Authentic check form with article, serial and batch numbers fields"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <h1 id="Manual-ForgotPassword">Forgot Password</h1>
              <p>
                If a user has forgotten the accounts password and wants to create a new password, the user can click on
                <em>Forgot your password? on the login screen or</em> go to the following URL:
                <br />
                <a
                  href="https://itemtracing.danielwellington.com/#/forgot-password"
                  className="external-link"
                  rel="nofollow"
                >
                  https://itemtracing.danielwellington.com/#/forgot-password
                </a>
              </p>
              <p> The user will then see the following screen: </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="150"
                    src={attachment92970935}
                    data-image-src={attachment92970935}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="92970935"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="forgot-password.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="5b5dcbbc-c225-4bda-81c9-27e439388cb0"
                    data-media-type="file"
                    alt="Form with email input and send button to restore password"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>
                The user can then type in the email of the account and request a new password. The user will be
                redirected to the following screen:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper confluence-embedded-manual-size">
                  <img
                    className="confluence-embedded-image"
                    height="250"
                    src={attachment92998910}
                    data-image-src={attachment92998910}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="92998910"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="new-password.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="612088a4-cc61-456b-8fe0-bf24efba74c0"
                    data-media-type="file"
                    alt="Form with email, verification number, new password and send button"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>
                The user will receive an email in the email account which was used to sign up with the subject
                <em>Verification code for ITS.</em> Open the email and the user will see a verification code.
              </p>
              <p>
                Copy the verification code, then go back to the password verification page and paste it in the
                <em>Verification Code</em> field.
              </p>
              <p>
                Type the email in the
                <em>Email</em> field, and enter the new password then click the
                <em>Send</em> button. The users new password will now be created and the user can log in.
              </p>
              <h1 id="Manual-Otherfunctions">Other functions</h1>
              <p>
                <br />
              </p>
              <h2 id="Manual-Userinfo&amp;Logout">User info &amp; Log out</h2>
              <p>
                The user can see their information: logged in email and company name by clicking on their username on
                the top right of the screen as show below:
              </p>
              <p>
                <span className="confluence-embedded-file-wrapper">
                  <img
                    className="confluence-embedded-image"
                    src={attachment91916770}
                    data-image-src={attachment91916770}
                    data-unresolved-comment-count="0"
                    data-linked-resource-id="91916770"
                    data-linked-resource-version="1"
                    data-linked-resource-type="attachment"
                    data-linked-resource-default-alias="Screen Shot 2017-02-20 at 15.03.05.png"
                    data-base-url="https://keycomponent.atlassian.net/wiki"
                    data-linked-resource-content-type="image/png"
                    data-linked-resource-container-id="91916606"
                    data-linked-resource-container-version="41"
                    data-media-id="121a7f22-2f35-46a6-9507-7946e587205f"
                    data-media-type="file"
                    alt="Hovered logout button"
                  />
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>The user can also log out from that menu.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
